import React, { ReactNode } from 'react';
import { Header } from './header';
import { Footer } from './footer';
import { PageContainer } from './ui';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1">
        <PageContainer>
          <div className="animate-fade-in">{children}</div>
        </PageContainer>
      </main>
      <Footer />
    </div>
  );
};
